import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';

const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="border-b border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left"
        onClick={onClick}
      >
        <h3 className="text-lg font-semibold text-[#113262] pr-8">{question}</h3>
        <ChevronDown
          className={`w-5 h-5 text-[#F49611] transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
            }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'
          }`}
      >
        <p className="text-gray-600">{answer}</p>
      </div>
    </div>
  );
};

const CoralFactorFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "What is the Coral Factor strategy?",
      answer: "CORAL Factors is our systematic factor investing strategy that leverages quantitative models to construct diversified portfolios across proven investment factors like value, momentum, quality, and low volatility. We use data-driven signals and risk management protocols to capture factor premiums while maintaining optimal risk-adjusted returns."
    },
    {
      question: "How does factor investing work?",
      answer: "Factor investing targets specific characteristics or 'factors' that historically drive returns, such as value (undervalued stocks), momentum (trending stocks), quality (financially strong companies), and low volatility (stable performers). Our strategy systematically allocates across these factors through ETFs using quantitative models and optimization techniques."
    },
    {
      question: "What are the investment specifications?",
      answer: "The minimum investment is Rs. 50 lakhs with a recommended time horizon of 3-5 years. Our multi-factor portfolio is rebalanced systematically based on quantitative signals and risk management protocols, ensuring optimal factor exposure and premium capture across market cycles."
    },
    {
      question: "Why use multiple factors?",
      answer: "Diversifying across multiple factors reduces concentration risk and provides more consistent returns than single-factor strategies. Our multi-factor approach captures different sources of return while managing correlations between factors, resulting in superior risk-adjusted performance and more stable factor premium capture."
    },
    {
      question: "How is factor allocation determined?",
      answer: "Factor allocation is determined through advanced quantitative models that process multiple data sources and signals. We use portfolio optimization techniques, volatility targeting, and correlation analysis to maintain optimal factor weights and capture factor premiums through disciplined rebalancing protocols."
    },
    {
      question: "Who should consider Coral Factors?",
      answer: "CORAL Factors is ideal for investors seeking systematic exposure to proven investment factors, those who value quantitative investment strategies with disciplined rebalancing, and investors looking for evidence-based factor investing with transparent methodology and sophisticated risk management frameworks."
    }
  ];


  return (
    <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
      <div className="flex flex-col md:flex-row gap-16">
        <div className="md:w-1/3">
          <div className="sticky top-8">
            <div className="w-12 h-0.5 bg-[#F49611] mb-3"></div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
              Common Questions About CORAL Factors
            </h2>
            <p className="text-gray-600 mb-8">
              Get answers to frequently asked questions about our quantitative factor investing strategy.
              For more detailed discussions, our investment experts are ready to help.
            </p>
            <a href="/meeting" className="flex items-center text-[#F49611] font-semibold hover:gap-2 transition-all">
              <span>Speak With An Expert</span>
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </div>
        </div>
        <div className="md:w-2/3">
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => setOpenIndex(index === openIndex ? -1 : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoralFactorFAQ;